import { CardTitle, ShadowCard } from 'components/Common';
import React from 'react';
import { OrderTypeMainEdit } from './OrderTypeEditMain';
import { Alert } from 'reactstrap';

export const OrderTypeMainCard = () => {
  return (
    <ShadowCard id="mainSettings" bodyStyle={{ padding: '24px' }}>
      <CardTitle title="orderTypes.main" />

      <Alert
        color="warning"
        className="py-2 px-3 small"
        style={{ fontSize: '13px' }}
      >
        <span className="fw-semibold">🔒 Restricted Access:</span> This page is
        available for <strong>Super Admins</strong> only.
      </Alert>

      <OrderTypeMainEdit />
    </ShadowCard>
  );
};
